{
  "/": {
    "title": "Managed Business Email for Your Domain | Envelaro",
    "description": "Business email, team chat and Envelaro Meet video meetings in one managed workspace. Custom-domain mailboxes, guided setup and organization-level plans."
  },
  "/about": {
    "title": "About Envelaro | Managed Business Email",
    "description": "Learn how Envelaro helps businesses run dependable custom-domain email with guided setup, clear administration, and responsive support."
  },
  "/product": {
    "title": "Managed Business Email Hosting & Workspace | Envelaro",
    "description": "Bring email, calendar, chat, video meetings and shared files together with Envelaro. Meet Lite supports one host and five guests, with a shared monthly allowance."
  },
  "/pricing": {
    "title": "Business Email Pricing & Plans | Envelaro",
    "description": "Compare Envelaro organization plans with business email, Envelaro Meet Lite video meetings and shared storage. Clear mailbox limits and meeting allowances."
  },
  "/small-business-email-hosting": {
    "title": "Small Business Email Hosting with Support | Envelaro",
    "description": "Managed business email hosting for small businesses, with custom-domain mailboxes, organization-level plans, guided DNS setup, migration, and support."
  },
  "/custom-domain-email-hosting": {
    "title": "Custom Domain Email Hosting for Business | Envelaro",
    "description": "Host professional business email on a domain you own, with guided verification, MX, SPF, DKIM, DMARC, mailbox administration, and migration support."
  },
  "/multiple-domain-email-hosting": {
    "title": "Multiple Domain Business Email Hosting | Envelaro",
    "description": "Manage business email for multiple verified domains with organization-level mailbox capacity, shared storage, guided authentication, and clear administration."
  },
  "/managed-email-setup": {
    "title": "Managed Business Email Setup Service | Envelaro",
    "description": "Set up business email with guided domain review, mailbox planning, DNS authentication, mail-flow testing, administrator handover, and migration coordination."
  },
  "/managed-private-deployment": {
    "title": "Private Business Email Deployment | Envelaro",
    "description": "Deploy Envelaro business email in a private managed environment with dedicated planning, migration, administration, and operational support."
  },
  "/security": {
    "title": "Business Email Security & Administration | Envelaro",
    "description": "See how Envelaro approaches business email security, domain authentication, access controls, administration, and operational resilience."
  },
  "/migration": {
    "title": "Business Email Migration Services | Envelaro",
    "description": "Move business email to Envelaro with guided discovery, mailbox migration, DNS coordination, validation, and a controlled cutover plan."
  },
  "/migration/cpanel": {
    "title": "Migrate cPanel Email to Envelaro | Guided Cutover",
    "description": "Plan a cPanel email migration to Envelaro while preserving website hosting and unrelated DNS, with mailbox inventory, authentication, testing, and controlled cutover."
  },
  "/migration/godaddy": {
    "title": "Migrate GoDaddy Business Email to Envelaro",
    "description": "Move email from GoDaddy to Envelaro after identifying the mailbox platform, preserving domain and website services, and validating mail flow before cancellation."
  },
  "/migration/google-workspace": {
    "title": "Migrate Google Workspace Email to Envelaro",
    "description": "Plan a Google Workspace email migration with Gmail mailbox inventory, administrator authorization, separate workload decisions, DNS cutover, and validation."
  },
  "/migration/microsoft-365": {
    "title": "Migrate Microsoft 365 Email to Envelaro",
    "description": "Prepare a Microsoft 365 email migration by mapping Exchange mailboxes, shared resources, identity dependencies, DNS changes, and post-cutover validation."
  },
  "/migration/zoho-mail": {
    "title": "Migrate Zoho Mail to Envelaro | Business Email",
    "description": "Move Zoho Mail to Envelaro with source-access review, mailbox and alias inventory, separate Workplace decisions, controlled DNS cutover, and testing."
  },
  "/faq": {
    "title": "Business Email FAQ | Envelaro",
    "description": "Get answers about Envelaro business email, custom domains, mailbox migration, administration, security, support, and service plans."
  },
  "/status": {
    "title": "Envelaro Service Status",
    "description": "View the current operational status of Envelaro public services and business email platform components."
  },
  "/tools/email-health": {
    "title": "Free Business Email Health Check | Envelaro",
    "description": "Check a domain's public email DNS configuration and review MX, SPF, DKIM, and DMARC findings with clear next steps."
  },
  "/tools/dmarc-checker": {
    "title": "Free DMARC Record Checker | Envelaro",
    "description": "Check a domain's DMARC record, enforcement policy, reporting, alignment and subdomain protection. Get clear guidance for fixing common DMARC issues."
  },
  "/tools/dkim-checker": {
    "title": "Free DKIM Record Checker | Envelaro",
    "description": "Verify a DKIM selector and public key for your sending domain. Review DKIM record evidence, common errors and practical remediation guidance."
  },
  "/tools/spf-checker": {
    "title": "Free SPF Record Checker | Envelaro",
    "description": "Check a domain's SPF record, authorized senders, enforcement and DNS lookup budget. Find syntax risks, deprecated mechanisms and practical fixes."
  },
  "/tools/domain-blocklist-checker": {
    "title": "Free Domain Blocklist Checker | Envelaro",
    "description": "Check a domain against named public reputation lists. Understand domain listings, inconclusive lookups, remediation and email deliverability limits."
  },
  "/tools/ip-blocklist-checker": {
    "title": "Free IP Blocklist Checker | Envelaro",
    "description": "Check a sending IPv4 address against named public DNS blocklists. Understand listings, unavailable queries and practical sender-reputation remediation."
  },
  "/resources": {
    "title": "Business Email Resources & Guides | Envelaro",
    "description": "Read practical Envelaro guides for business email setup, domain authentication, deliverability, migration, security, and administration."
  },
  "/resources/dkim-guide": {
    "title": "DKIM Guide for Business Email | Envelaro",
    "description": "Understand DKIM selectors, signing, public-key DNS records, message verification, alignment and practical troubleshooting using primary sources."
  },
  "/resources/dmarc-guide": {
    "title": "DMARC Alignment & Rollout Guide | Envelaro",
    "description": "Learn how DMARC evaluates aligned SPF or DKIM, how policy and reporting tags work, and how to move toward enforcement safely."
  },
  "/resources/email-deliverability-guide": {
    "title": "Business Email Deliverability Guide | Envelaro",
    "description": "Build a practical email deliverability program across authentication, recipient permission, reputation, monitoring and incident response."
  },
  "/resources/business-email-provider-comparison": {
    "title": "Business Email Provider Comparison Checklist | Envelaro",
    "description": "Use a practical checklist to compare business email providers on total cost, domains, storage, migration, security, support and exit requirements."
  },
  "/contact": {
    "title": "Contact Envelaro | Business Email",
    "description": "Contact Envelaro to discuss managed business email, mailbox migration, custom-domain setup, security, pricing, or private deployment."
  },
  "/evaluation": {
    "title": "Evaluate Envelaro Managed Business Email",
    "description": "Apply to evaluate Envelaro business email with guided domain setup, mailbox administration, security guidance, webmail, migration planning, and candid feedback."
  },
  "/privacy": {
    "title": "Privacy Notice | Envelaro",
    "description": "Read how Envelaro collects, uses, shares, retains, and protects personal data submitted through its website and services."
  },
  "/terms": {
    "title": "Website Terms of Use | Envelaro",
    "description": "Read the terms that govern access to and use of the Envelaro public website, content, enquiries, and related services."
  },
  "/acceptable-use": {
    "title": "Acceptable Use Policy | Envelaro",
    "description": "Review the rules for responsible and permitted use of Envelaro services, including sending, account security, and prohibited activity."
  },
  "/cookies": {
    "title": "Cookie Notice | Envelaro",
    "description": "Learn how Envelaro uses cookies and similar technologies on its public website and how visitors can manage their choices."
  },
  "/dpa": {
    "title": "Data Processing Addendum | Envelaro",
    "description": "Review Envelaro's data processing terms, security commitments, international transfer provisions, and customer responsibilities."
  },
  "/subprocessors": {
    "title": "Subprocessors | Envelaro",
    "description": "View the third-party subprocessors Envelaro uses to provide, secure, support, and operate its business email services."
  },
  "/service-availability": {
    "title": "Service Availability | Envelaro",
    "description": "Review Envelaro service availability commitments, planned maintenance, incident handling, exclusions, and customer responsibilities."
  },
  "/service-model": {
    "title": "Managed Service Model | Envelaro",
    "description": "Understand how Envelaro manages business email setup, administration, support, security, migration, and ongoing operations."
  },
  "/service-terms": {
    "title": "Service Terms | Envelaro",
    "description": "Read the terms governing paid Envelaro business email services, customer accounts, subscriptions, support, and service use."
  },
  "/billing-policy": {
    "title": "Billing, Cancellation & Refund Policy | Envelaro",
    "description": "Review Envelaro billing, renewal, cancellation, refund, payment failure, and subscription change policies."
  },
  "/data-lifecycle": {
    "title": "Data Lifecycle & Export Policy | Envelaro",
    "description": "Understand how Envelaro handles customer data creation, retention, export, deletion, backups, and account closure."
  },
  "/resources/business-email-migration-checklist": {
    "title": "Moving business email: what to check before changing providers | Envelaro",
    "description": "A practical checklist for protecting your domain, mailbox history and daily work when moving business email to a new provider."
  },
  "/resources/spf-dkim-dmarc-explained": {
    "title": "SPF, DKIM and DMARC explained for business owners | Envelaro",
    "description": "Understand what the three email authentication controls do, what they cannot prove, and what to ask the person managing your business domain."
  },
  "/resources/evaluate-envelaro-secondary-domain": {
    "title": "How to evaluate Envelaro using a secondary domain before moving your main email | Envelaro",
    "description": "Plan a small Envelaro evaluation, test everyday email and administration, and decide whether to proceed while your primary email stays with its current provider."
  }
}
